
/* ================ MODAL CONFIRM ================ */
// Get the modal
var modal = document.getElementById("myModal");

// Get the button that opens the modal
var btn = document.getElementById("myBtn");

// Get the <span> element that closes the modal
var span = document.getElementsByClassName("closeconfirm")[0];

// When the user clicks on the button, open the modal
btn.onclick = function() {
  
  let inputName = document.getElementsByClassName("class_name")[0].value;
  let inputEmail = document.getElementsByClassName("class_email")[0].value;
  let inputPhone = document.getElementsByClassName("class_phone")[0].value;
  let inputMessage = document.getElementsByClassName("class_message")[0].value;
  
  document.getElementById("nameConfirm").innerHTML = inputName;
  document.getElementById("emailConfirm").innerHTML = inputEmail; 
  document.getElementById("phoneConfirm").innerHTML = inputPhone; 
  document.getElementById("messageConfirm").innerHTML = inputMessage; 
  
  modal.style.display = "block";
  
  
}

// When the user clicks on <span> (x), close the modal
span.onclick = function() {
  modal.style.display = "none";
}

// When the user clicks anywhere outside of the modal, close it
window.onclick = function(event) {
  if (event.target == modal) {
    modal.style.display = "none";
  }
}
